import { h, Component, Prop } from '@stencil/core';


@Component({
  tag: 'tip-presentation-button'
})
export class PresentationButton {
  @Prop() presentationType: string;
  @Prop() presentationDate: string;

  handleClick(_e) {
    this.openPresentation()
  }

  openPresentation() {
    let root = document.querySelector('tip-root');
    let url = `presentation.html?type=${this.presentationType}&date=${this.presentationDate}&layers=${root.layers}&baseUrl=${root.baseUrl}&revision=${root.revision}`;
    window.open(url);
  }

  render() {
    return (
      <ion-button onClick={ (e) => this.handleClick(e) } size='small'>
        <ion-icon name="easel" slot='start'></ion-icon>Presentation
      </ion-button>
    )
  }
}
